"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useErrorToast } from "@/hooks/useErrorToast";
import { logClientErrorWithContext } from "@/lib/logger/src/logClientErrorWithContext";
import { normalizeLocale } from "@/utils/localeUtil";

export const useHeader = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const handleClientApiError = useErrorToast();

  const languageCode = normalizeLocale(searchParams?.get("locale"));
  const channel = searchParams?.get("channel");

  const handleSignOut = async (): Promise<void> => {
    try {
       await fetch("/api/signout");
      router.push("/");
    } catch (err) {
      logClientErrorWithContext({
        alertName: "QRV_CORP_ERROR_SESSION",
        error: err,
        pageName: "useHeader",
        apiName: "/api/signout",
        httpMethod: "GET",
        correlationId: "",
        operation: "",
        operationSignature: "",
      });
      handleClientApiError();
    }
  };

  const handleLanguageChange = async (nextLangCode: string) => {
    try {
      const resp = await fetch("/api/updateLanguage", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ locale: nextLangCode }),
      });
      if (!resp.ok) {
        throw new Error("Failed to update language cookie");
      }
      window.location.reload();
    } catch (err) {
      console.error(err);
      handleClientApiError();
    }
  };

  return {
    languageCode,
    handleSignOut,
    handleLanguageChange,
    channel,
  };
};
